import CompositeFormField from './composite-field.js';
export default class AddressHistory extends CompositeFormField {
    constructor(parent, el) {
        super(parent, el);
        this.minYears = Number(this.el.dataset.minYears);
        this.minMonths = Number(this.minYears) * 12;

        this.address0Container = el.querySelector('.address0Container');
        this.address0 = this.field('address0');
        this.address0Duration = this.field('address0Duration');
        this.address0Years = this.address0Duration.input('years');
        this.address0Months = this.address0Duration.input('months');

        this.address1Container = el.querySelector('.address1Container');
        this.address1 = this.field('address1');
        this.address1Duration = this.field('address1Duration');
        this.address1Years = this.address1Duration.input('years');
        this.address1Months = this.address1Duration.input('months');

        this.address2Container = el.querySelector('.address2Container');
        this.address2 = this.field('address2');
        this.address2Duration = this.field('address2Duration');
        this.address2Years = this.address2Duration.input('years');
        this.address2Months = this.address2Duration.input('months');
        this.bind();
    }

    bind() {
        this.form.addEventListener('onUpdate', () => this.onUpdate());
    }

    onUpdate() {
        this.showPreviousAddresses();
    }

    showPreviousAddresses() {
        if(!this.empty(this.address0Years) && !this.empty(this.address0Months)) {
            const months = (Number(this.address0Years.el.value) * 12) + Number(this.address0Months.el.value);
            if(months < this.minMonths) {
                this.address1Container.classList.remove('hide');
                this.address1.enable();                
                this.address1Duration.enable();
            } else {
                this.address1Container.classList.add('hide');
                this.address1.disable();
                this.address1Duration.disable();

                this.address2Container.classList.add('hide');
                this.address2.disable();
                this.address2Duration.disable();
            }
        }

        if(!this.empty(this.address1Years) && !this.empty(this.address1Months)) {
            const months = (Number(this.address0Years.el.value) * 12) + Number(this.address0Months.el.value)
                            + (Number(this.address1Years.el.value) * 12) + Number(this.address1Months.el.value);
            if(months < this.minMonths) {
                this.address2Container.classList.remove('hide');
                this.address2.enable();
                this.address2Duration.enable();
            } else {
                this.address2Container.classList.add('hide');
                this.address2.disable();
                this.address2Duration.disable();
            }
        }
    }

    empty(input) {
        return input.el.value == null || input.el.value == '';
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_address_history');
    }
}
